/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdditionalBillingProfileAddress } from './';
import {
    AdditionalBillingProfileAddressFromJSON,
    AdditionalBillingProfileAddressFromJSONTyped,
    AdditionalBillingProfileAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateAdditionalBillingProfileRequest
 */
export interface UpdateAdditionalBillingProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalBillingProfileRequest
     */
    label: string;
    /**
     * 
     * @type {AdditionalBillingProfileAddress}
     * @memberof UpdateAdditionalBillingProfileRequest
     */
    address: AdditionalBillingProfileAddress;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdditionalBillingProfileRequest
     */
    registrationNumber?: string;
}

/**
 * Check if a given object implements the UpdateAdditionalBillingProfileRequest interface.
 */
export function instanceOfUpdateAdditionalBillingProfileRequest(value: object): value is UpdateAdditionalBillingProfileRequest {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function UpdateAdditionalBillingProfileRequestFromJSON(json: any): UpdateAdditionalBillingProfileRequest {
    return UpdateAdditionalBillingProfileRequestFromJSONTyped(json, false);
}

export function UpdateAdditionalBillingProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAdditionalBillingProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'address': AdditionalBillingProfileAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
    };
}

export function UpdateAdditionalBillingProfileRequestToJSON(value?: UpdateAdditionalBillingProfileRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'address': AdditionalBillingProfileAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
    };
}

